import React,{useEffect} from 'react'
import './index.scss'
import {connect} from 'react-redux'
import ForddTopTit from '@/components/forddtopt'
import {setTit} from '@/utils/settit'
const mapStateToProps = (state) => ({
  tenant : state.getIn(['tenantReducer','tenant'])
})
const Call = (props) => {
  // let {tenant} = props
  useEffect(() => {
    document.title = `「${setTit()}」 一键报警`
    return () => {
      document.title = ''
    }
  }, [])
  return (
    <div className="call__box">
      {/* <p className="top-title">本次服务由「{tenant}」为您提供</p> */}
      <ForddTopTit/>
      <div className="call-info__show">
        <div className="call-info__con">
          <div className="call-tit">
            <h2>谎报警情，依法追责</h2>
            <h3>谎报警情将可能被处以五日以上十日以下拘留</h3>
          </div>
          <div className="call-list">
            <h2>一键报警</h2>
            <h3>点击“呼叫110”后，您可以直接拨打本地110</h3>
          </div>
          <div className="call-list">
            <h2>如遇险情，请您尽快向警方求助！请不要恶意报警！</h2>
            <h3>恶意报警将会受到法律处罚</h3>
          </div>
          <div className="call-warn">
            <p>1、骚扰警情处罚依据：《治安管理处罚法》第二十三条第（一）项：处警告或者二百元以下罚款；情节较重的，处五日以上十日以下拘留，可以并处五百元以下罚款。</p>
            <p>2、谎报警情处罚依据：《治安管理处罚法》第二十五条第（一）项：处五日以上十日以下拘留，可以并处五百元以下罚款；情节较轻的，处五日以上拘留或者五百元以下罚款。</p>
          </div>
        </div>
      </div>
      <footer>
        <a href="tel:110">呼叫110</a>
      </footer>
    </div>
  )
}
export default connect(mapStateToProps)(Call)
